<div class="container-fluid">
  <div class="container">
    <div class="org-management-cards-wrapper">
      @if (userCanCreateOrganization) {
        <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['../new']">
          <mat-label class="text-center">
            <mat-icon class="org-management-icon">add</mat-icon>
            <h2>{{'pages.organizations.organization-management.component.organization-create' | translate}}</h2>
          </mat-label>
        </div>
      }
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./show']">
        <mat-label class="text-center">
          <mat-icon class="org-management-icon">business</mat-icon>
          <h2>{{'pages.organizations.organization-management.component.organization-view' | translate}}</h2>
        </mat-label>
      </div>
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./user']">
        <mat-label class="text-center">
          <mat-icon class="org-management-icon">people</mat-icon>
          <h2>{{'generic.users' | translate}}</h2>
        </mat-label>
      </div>
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./documents']">
        <mat-label class="text-center">
          <fa-icon [icon]="faFile" class="org-management-icon"> </fa-icon>
          <h2>{{'generic.documents' | translate}}</h2>
        </mat-label>
      </div>
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./email-templates']">
        <mat-label class="text-center">
          <fa-icon [icon]="faEnvelope" class="org-management-icon"> </fa-icon>
          <h2>{{'generic.mail-template' | translate}}</h2>
        </mat-label>
      </div>
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./organization-charts']">
        <mat-label class="text-center">
          <mat-icon class="org-management-icon">account_tree</mat-icon>
          <h2>{{'generic.organization-charts' | translate}}</h2>
        </mat-label>
      </div>
      <div class="mat-elevation-z8 box-sections org-management-card" [routerLink]="['./project-properties']">
        <mat-label class="text-center">
          <mat-icon class="org-management-icon">settings</mat-icon>
          <h2>{{'pages.organizations.organization-management.component.project-properties' | translate}}</h2>
        </mat-label>
      </div>
    </div>
  </div>
</div>
<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [routerLink]="['/home']" routerLinkActive="router-link-active">
    <i class="icon-Backward-arrow-small"></i>
    {{'generic.buttons.home' | translate}}
  </button>
</div>
